<dgx-components-icon
  *ngIf="iconName"
  [name]="iconName"
  size="sm"
  [ngClass]="{
    'envelope-icon-style': iconName === 'envelope',
    'phone-icon-style': iconName === 'phone',
    'mobile-device': isMobile
  }"
>
</dgx-components-icon>

<section class="content-display">
  <ng-content> </ng-content>
</section>
